import React from 'react';
import { SelectButton } from 'primereact/selectbutton';
import { ExpeditionTypeEnum } from '@api/ringil-api.v2';
import { useTranslation } from 'react-i18next';
import ButtonLayout from '@components/obsolete/Form/ButtonLayout/ButtonLayout.tsx';

interface ComponentProps {
  value?: ExpeditionTypeEnum | null;
  // Deselecting the active button yields null = no shipment type (RD-2961).
  onChange: (expeditionType: ExpeditionTypeEnum | null) => void;
  errorMessages?: string;
}

export const TransportationTypeSelector: React.FC<ComponentProps> = ({ value, onChange, errorMessages }) => {
  const { t } = useTranslation();

  const loadTypes = [
    {
      label: t('loadDetailsPage.panelShipmentType.buttonFTL'),
      value: ExpeditionTypeEnum.FULL_TRUCK_LOAD,
    },
    {
      label: t('loadDetailsPage.panelShipmentType.buttonLTL'),
      value: ExpeditionTypeEnum.LESS_TRUCK_LOAD,
    },
    {
      label: t('loadDetailsPage.panelShipmentType.buttonSBERKA'),
      value: ExpeditionTypeEnum.SBERKA,
    },
    {
      label: t('loadDetailsPage.panelShipmentType.buttonLCL'),
      value: ExpeditionTypeEnum.LCL,
    },
    {
      label: t('loadDetailsPage.panelShipmentType.buttonFCL'),
      value: ExpeditionTypeEnum.FCL,
    },
  ];

  return (
    <>
      <div className="p-field">
        <ButtonLayout label={t(`TransportationTypeSelector.transportationType`, `Transportation type`)} wrapper="WITHOUT_PADDING_BOTTOM">
          <SelectButton
            options={loadTypes}
            value={value}
            onChange={e => {
              onChange(e.value ?? null);
            }}
          />
        </ButtonLayout>
      </div>
    </>
  );
};
